<template>
    <div class="information">
        <!-- <van-button @click="jumpPage" type="primary">爆料</van-button> -->
        <div class="home-header-box clear">
            <a class="home-logo fl"><img class="display-a" :src="logo" /></a>
            <div @click="jumpSearch" class="home-search">
                <input type="text" placeholder="搜索" />
            </div>
            <a @click="jumpDown" class="fr camera-a"></a>
        </div>
        <!-- 模块 -->
        <div class="par-two" style="padding-top: 60px">
            <!-- <ul class="home-top">
                <li v-for="(item, index) in m_menus" :key="index">
                    <a>
                        <img :src="item.icon" />
                        <p>{{ item.title }}</p>
                    </a>
                </li>
                <li v-if="m_menus_num > 4">
                    <a @click="jumpDown">
                        <img :src="m_menu_more.img" />
                        <p>{{ m_menu_more.text }}</p>
                    </a>
                </li>
            </ul> -->
            <div :class="['home-title-div', tabMenuFlag ? 'tabActive' : '']">
                <ul class="home-title">
                    <li
                        v-for="(item, index) in tabMenus"
                        :key="index"
                        @click="checkTab(index, item)"
                        :class="{ 'home-title-li': tabIndex == index }"
                    >
                        <a>{{ item.name }}</a>
                    </li>
                </ul>
                <!-- <a @click="jumpDown" v-if="tabMenus.length > 5" :style="{'right':tabMenuFlag ? '0':'-20px'}" class="home-title-more"></a> -->
            </div>
        </div>
        <!-- 莞香号金刚区 -->
        <ul
            v-show="is_dy"
            class="subscriptions-ul flex justify-bet Subscribe-ul"
        >
            <li class="Subscribe-li1">
                <a @click="jumpPage2(0)">
                    <i></i><span class="fl">我的订阅</span>
                </a>
            </li>
            <li class="Subscribe-li2">
                <a @click="jumpPage2(1)">
                    <i></i><span class="fl">申请入驻</span>
                </a>
            </li>
            <li class="Subscribe-li3" @click="jumpAllType">
                <a><i></i><span class="fl">全部分类</span> </a>
            </li>
        </ul>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <!-- 莞香号 -->
            <div class="m_dy" v-show="is_dy">
                <!-- 列表前三条 -->
                <div class="listBox">
                    <!-- 标题 -->
                    <div class="titleBox">热门文章</div>
                    <!-- 小图 -->
                    <div
                        v-for="item in hotList"
                        :key="item.id"
                        :class="[
                            'item',
                            'b_img',
                            item.app_card == 0 ? 'flex justify-bet' : '',
                        ]"
                        @click="jumpDetails(item.share_url)"
                    >
                        <div
                            :class="[
                                'info',
                                item.app_card == 0
                                    ? 'flex justify-bet flex-column'
                                    : item.app_card == 1
                                    ? 'flex justify-bet'
                                    : '',
                            ]"
                        >
                            <p
                                :class="[
                                    'title van-multi-ellipsis--l2',
                                    item.app_card == 1 ? 'flex_1 pr12' : '',
                                ]"
                            >
                                {{ item.title }}
                            </p>
                            <div
                                v-if="item.app_card == 0"
                                class="option flex align-center mt12"
                            >
                                <div class="userBox flex align-center">
                                    <img :src="item.user.image" alt="" />
                                    <span>{{ item.user.nickname }}</span>
                                </div>
                                <span class="time">{{
                                    item.published_des
                                }}</span>
                            </div>
                            <van-image
                                lazy-load
                                fit="cover"
                                width="120"
                                height="80"
                                :src="item.image"
                                v-if="item.app_card == 1"
                            />
                        </div>
                        <!-- 大图 -->
                        <div v-if="item.app_card == 2" class="imgBox mt12">
                            <van-image
                                lazy-load
                                fit="cover"
                                width="100%"
                                height="100%"
                                :src="item.image"
                            />
                            <i class="playBtn"></i>
                        </div>
                        <!-- 三图 -->
                        <div v-if="item.app_card == 3" class="imgBoxs mt12">
                            <van-image
                                lazy-load
                                fit="cover"
                                class="img"
                                v-for="(elem, index) in item.images"
                                :key="index"
                                :src="elem"
                            />
                            <span v-if="item.images.length > 3" class="count"
                                >5图</span
                            >
                        </div>
                        <div
                            v-if="!(item.app_card == 0)"
                            class="option flex align-center mt12"
                        >
                            <div class="userBox flex align-center">
                                <img :src="item.user.image" alt="" />
                                <span>{{ item.user.nickname }}</span>
                            </div>
                            <span class="time">{{ item.published_des }}</span>
                        </div>
                    </div>
                </div>
                <!-- 后几条 -->
                <div class="listBox">
                    <div class="titleBox" @click="jumpAllType">
                        最新发布<span>全部</span>
                    </div>
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="initDyNewSend"
                        :immediate-check="true"
                    >
                        <van-cell v-for="item in newSendList" :key="item.id">
                            <div
                                :class="[
                                    'item',
                                    'b_img',
                                    item.app_card == 0
                                        ? 'flex justify-bet'
                                        : '',
                                ]"
                                @click="jumpDetails(item.share_url)"
                            >
                                <div
                                    :class="[
                                        'info',
                                        item.app_card == 0
                                            ? 'flex justify-bet flex-column'
                                            : item.app_card == 1
                                            ? 'flex justify-bet'
                                            : '',
                                    ]"
                                >
                                    <p
                                        :class="[
                                            'title van-multi-ellipsis--l2',
                                            item.app_card == 1
                                                ? 'flex_1 pr12'
                                                : '',
                                        ]"
                                    >
                                        {{ item.title }}
                                    </p>
                                    <div
                                        v-if="item.app_card == 0"
                                        class="option flex align-center mt12"
                                    >
                                        <div class="userBox flex align-center">
                                            <img
                                                :src="item.user.image"
                                                alt=""
                                            />
                                            <span>{{
                                                item.user.nickname
                                            }}</span>
                                        </div>
                                        <span class="time">{{
                                            item.published_des
                                        }}</span>
                                    </div>
                                    <van-image
                                        lazy-load
                                        fit="cover"
                                        width="120"
                                        height="80"
                                        :src="item.image"
                                        v-if="item.app_card == 1"
                                    />
                                </div>
                                <!-- 大图 -->
                                <div
                                    v-if="item.app_card == 2"
                                    class="imgBox mt12"
                                >
                                    <van-image
                                        lazy-load
                                        fit="cover"
                                        width="100%"
                                        height="100%"
                                        :src="item.image"
                                    />
                                    <i class="playBtn"></i>
                                </div>
                                <!-- 三图 -->
                                <div
                                    v-if="item.app_card == 3"
                                    class="imgBoxs mt12"
                                >
                                    <van-image
                                        lazy-load
                                        fit="cover"
                                        class="img"
                                        v-for="(elem, index) in item.images"
                                        :key="index"
                                        :src="elem"
                                    />
                                    <span
                                        v-if="item.images.length > 3"
                                        class="count"
                                        >5图</span
                                    >
                                </div>
                                <div
                                    v-if="!(item.app_card == 0)"
                                    class="option flex align-center mt12"
                                >
                                    <div class="userBox flex align-center">
                                        <img :src="item.user.image" alt="" />
                                        <span>{{ item.user.nickname }}</span>
                                    </div>
                                    <span class="time">{{
                                        item.published_des
                                    }}</span>
                                </div>
                            </div>
                        </van-cell>
                    </van-list>
                </div>
            </div>
            <!-- 主要内容 -->
            <div class="m_content">
                <!-- 轮播 -->
                <div class="swiperBox" v-if="swiperData.length > 0">
                    <Swiper :isUrl="false" :swiperData="swiperData" />
                </div>
                <!-- 列表 -->
                <!-- <InfoList :datas="listData1" /> -->
                <!-- 拍客 -->
                <!--拍客推荐-->
                <!-- <div class="patting-title" v-show="tabIndex == 0">
                    <span>拍客推荐</span><a @click="jumpMore" class="patting-more fr">更多<i></i></a>
                </div>
                <div v-show="tabIndex == 0">
                    <ul class="patting-remmend">
                        <li v-for="item in patCommentList" :key="item.id">
                            <a @click="jump_patting(item.share)">
                                <div class="patting-rem-top">
                                    <img :src="item.cover" class="patting-img" />
                                    <div class="clear patting-rem-po">
                                        <div class="fl patting-head">
                                            <van-image
                                                lazy-load
                                                fit="cover"
                                                width="24"
                                                height="24"
                                                :src="item.user.image"
                                            />
                                        </div>
                                        <div class="fl patting-name">{{item.user.nickname}}</div>
                                        <div class="fr playback-fr"><i></i>{{item.views}}</div>
                                    </div>
                                </div>
                                <div class="playback-bottom van-multi-ellipsis--l2"><p style="overflow: hidden;">{{item.content}}</p></div>
                            </a>
                        </li>
                    </ul>
                </div> -->
                <!-- 列表 -->
                <!-- 加载更多的列表 -->
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="initListContent"
                    :van-clearfix="true"
                    :immediate-check="false"
                >
                    <van-cell v-for="item in listData2" :key="item.id">
                        <InfoList :loadMore="true" :dataItem="item" />
                    </van-cell>
                </van-list>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
import {
    test,
    getInfomation,
    getInfomationList,
    getPattingComment,
    getDyNewSend,
    getDyHot,
} from "@/request/api";
import { InfoList, Swiper } from "@/components";
import Contents from "@/request/base.default.js";
import { myListener } from "../../../../../util";
import { navigate, checkWx } from "@/pages/index/custom";
import { Toast } from "vant";
// import { navigate } from '@/pages/index/custom'

export default {
    components: {
        InfoList,
        Swiper,
    },
    data() {
        return {
            id: "",
            logo: require("./images/indexLogo.png"),
            // 模块菜单
            m_menus: [],
            m_menus_num: 0,
            m_menu_more: { img: require("./images/home6.png"), text: "更多" },
            // 选项卡菜单
            tabMenus: [],
            tabIndex: 0,
            // 轮播
            current: 0,
            swiperData: [],
            // 前五条
            // listData1: [],
            // 剩余列表
            listData2: [],
            listPage: 1,
            loading: true, // 加载中
            finished: false, // 加载完毕
            // 拍客推荐
            patCommentList: [],
            tabMenuFlag: false,
            isLoading: false,
            is_dy: false,
            // 热门列表
            hotList: [],
            // 最新发布
            newSendList: [],
        };
    },
    methods: {
        // 详情页跳转
        jumpDetails(url) {
            navigate("", url);
        },
        // 订阅号热门文章
        initDyHot() {
            getDyHot()
                .then((res) => {
                    let { data, error_code } = res;
                    if (error_code === 0) {
                        this.hotList = data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 最细发布
        initDyNewSend() {
            getDyNewSend({
                page: this.listPage,
                pcount: 10,
            })
                .then((res) => {
                    let { data, error_code } = res;
                    this.isLoading = false;
                    if (error_code === 0) {
                        if (data.length === 0 || !data) {
                            this.finished = true;
                            return false;
                        }
                        data.map((item) => this.newSendList.push(item));
                        this.listPage++;
                        this.loading = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        jumpPage() {
            this.pagesJump("/baoliao/baoliao.html");
        },
        jumpSearch() {
            window.localStorage.setItem("h5_index_search_focus", 1);
            navigate("", Contents.mainURL + "/app/index/search");
        },
        jumpDown() {
            if (checkWx()) {
                navigate("", Contents.downURL + "?mini=1");
            } else {
                navigate("", Contents.downURL);
            }
        },
        // tab选项卡
        checkTab(index, item) {
            let { id, type = null } = item;

            this.swiperData = [];
            // this.listData1 = [];
            this.listData2 = [];
            this.listPage = 1;
            this.loading = true;
            this.tabIndex = index;
            this.id = id;
            if (type && type === 1) {
                // this.$router.push({path: "/subscribe", query: {id: index}})
                this.is_dy = true;
                this.initDyNewSend();
                this.initDyHot();
            } else {
                this.is_dy = false;
                this.initListContent();
            }
        },
        // 金刚区跳转
        jumpPage2(index) {
            if (index === 0) {
                navigate("/myDy");
            } else {
                if (checkWx()) {
                    navigate("", Contents.downURL + "?mini=1");
                } else {
                    navigate("", Contents.downURL);
                }
            }
        },
        // 跳到全部分类
        jumpAllType() {
            navigate("/allType");
        },
        // 获取频道/栏目
        initIndexData() {
            let { id = null, index = null } = this.$route.query;
            getInfomation()
                .then((res) => {
                    let { server, server_num, show, error_code } = res;
                    if (error_code === 0) {
                        this.m_menus = server;
                        this.m_menus_num = server_num;
                        this.tabMenus = show;
                        if (id && index) {
                            this.id = id;
                            this.tabIndex = index;
                        } else {
                            this.id = this.tabMenus[0].id;
                        }
                        this.initListContent();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 获取列表内容
        initListContent() {
            getInfomationList({
                chan_id: this.id,
                page: this.listPage,
                pcount: 10,
                is_h5: 1,
            })
                .then((res) => {
                    let { data, focus, error_code } = res;
                    this.isLoading = false;
                    if (error_code === 0) {
                        if (data.length === 0 || !data) {
                            this.finished = true;
                            return false;
                        }
                        if (this.listPage === 1) {
                            this.swiperData = [];
                            for (const item of focus) {
                                // if (item.cid > 0) {
                                    this.swiperData.push(item);
                                // }
                            }
                            var arr1 = [];
                            var arr2 = [];
                            // data.forEach((item, index) => {
                            //     if(index < 3) {
                            //         arr1.push(item)
                            //     } else {
                            //         arr2.push(item)
                            //     }
                            // });
                            // this.listData1 = arr1;
                            this.listData2 = data;
                        } else {
                            data.map((item) => this.listData2.push(item));
                        }
                        this.listPage++;
                        this.loading = false;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
        // 拍客推荐
        initPatComment() {
            getPattingComment({
                id: 0,
                page: 10,
            })
                .then((res) => {
                    let { data, error_code } = res;
                    if (error_code === 0) {
                        if (data.length > 0) {
                            data.map((item) => {
                                if (!item.adv_data) {
                                    if (this.patCommentList.length < 5) {
                                        return this.patCommentList.push(item);
                                    }
                                }
                            });
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // 上拉刷新
        onRefresh() {
            // this.listData1 = [];
            this.listData2 = [];
            this.listPage = 1;
            this.loading = true;
            this.finished = false;
            this.initListContent();
            this.initPatComment();

            // setTimeout(() => {
            //     Toast('刷新成功');
            //     this.isLoading = false;
            //     this.count++;
            // }, 1000);
        },
    },
    created() {
        this.initIndexData();
        this.initPatComment();
        this.listen = myListener(
            window,
            "scroll",
            (e) => {
                var scrollTop =
                    e.target.documentElement.scrollTop ||
                    e.target.body.scrollTop;
                if (scrollTop > 250) {
                    this.tabMenuFlag = true;
                } else {
                    this.tabMenuFlag = false;
                }
            },
            true
        );
        // this.initListContent();
    },
    destroyed() {
        this.listen();
    },
};
</script>

<style lang="less" scoped>
@import "./css/public_style.css";
@import "./css/style.css";
.userBox {
    height: 1.5rem;
    line-height: 1.5rem;
    img {
        width: 1.5rem;
        height: 24px;
        object-fit: cover;
        border-radius: 50%;
        display: block;
        overflow: hidden;
    }
    span {
        font-size: 12px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        margin: 0 6px;
    }
}
.listBox {
    box-sizing: border-box;
    padding: 0 20px;
    .pr12 {
        padding-right: 0.75rem;
    }
    .mt8 {
        margin-top: 0.5rem !important;
    }
    .mt12 {
        margin-top: 0.75rem !important;
    }
    .item {
        border-bottom: 1px solid #eee;
    }
    .s_img {
        padding: 20px 0;
        box-sizing: border-box;
        .info {
            box-sizing: border-box;
            padding-right: 0.75rem;
        }
        .title {
            font-size: 18px;
            font-weight: 500;
            color: rgba(34, 34, 34, 1);
            line-height: 25px;
        }
    }
    .b_img {
        box-sizing: border-box;
        padding: 20px 0;
        .living {
            position: absolute;
            top: 0.75rem;
            right: 0.75rem;
            height: 20px;
            line-height: 20px;
            padding-right: 8px;
            padding-left: 22px;
            background: url(../../../../assets/img/ic_live_s.png) no-repeat 8px
                center;
            background-size: 12px 12px;
            background-color: #ff4c67;
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            border-radius: 2px;
        }
        .huigu {
            position: absolute;
            top: 0.75rem;
            right: 0.75rem;
            height: 20px;
            line-height: 20px;
            padding: 0 8px;
            background-color: #00c5aa;
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            border-radius: 2px;
            text-align: center;
        }
        .yugao {
            position: absolute;
            top: 0.75rem;
            right: 0.75rem;
            height: 20px;
            line-height: 20px;
            padding: 0 8px;
            background-color: #2e8cff;
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            border-radius: 2px;
            text-align: center;
        }
        .playBtn {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -1.75rem;
            margin-top: -1.75rem;
            width: 3.5rem;
            height: 3.5rem;
            background: url(../../../../assets/img/ic_playBtn.png) no-repeat;
            background-size: 100% 100%;
        }
        .liveBtn {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -1.75rem;
            margin-top: -1.75rem;
            width: 3.5rem;
            height: 3.5rem;
            background: url(../../../../assets/img/ic_live_b.png) no-repeat;
            background-size: 100% 100%;
        }
        .title {
            font-size: 18px;
            font-weight: 500;
            color: rgba(34, 34, 34, 1);
            line-height: 26px;
            max-height: 52px;
        }
        .imgBox {
            width: 100%;
            height: 11.75rem;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
        }
        .imgBoxs {
            width: 100%;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
            .img {
                float: left;
                width: 32.8%;
                height: 4.625rem;
            }
            & > .img:nth-child(2) {
                margin: 0 0.8%;
            }
            .count {
                position: absolute;
                right: 0.5rem;
                bottom: 0.5rem;
                width: auto;
                height: 1.25rem;
                line-height: 1.25rem;
                padding: 0 0.5rem;
                font-size: 12px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                border-radius: 100px;
                background-color: rgba(0, 0, 0, 0.7);
            }
        }
    }
    .option {
        margin: 0;
        .else {
            width: 32px;
            height: 21px;
            margin-right: 4px;
            text-align: center;
            line-height: 21px;
            font-size: 9px;
            font-weight: 400;
            transform: scale(0.75);
            border-radius: 2px;
        }
        .time {
            font-size: 12px;
            font-weight: 400;
            color: rgba(167, 167, 167, 1);
            line-height: 21px;
        }
    }
}
.titleBox {
    width: 100%;
    height: 3.75rem;
    box-sizing: border-box;
    padding: 0 0.625rem;
    font-size: 20px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    position: relative;
    line-height: 3.75rem;
    span {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        padding-right: 1.25rem;
        background: url(./images/icon_news_right.png) no-repeat center right;
        background-size: 1rem 1rem;
        font-size: 12px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
    }
    &::after {
        content: "";
        position: absolute;
        top: 50%;
        margin-top: -0.625rem;
        left: 0;
        width: 3px;
        height: 20px;
        background: rgba(255, 76, 103, 1);
        border-radius: 10px;
    }
}
.patting-head {
    overflow: hidden;
    border-radius: 50%;
}
.information {
    padding-bottom: 3.75rem;
}
.detail-adv-img {
    width: 100%;
    height: 11.75rem;
    object-fit: cover;
}
.swiperBox {
    box-sizing: border-box;
    padding: 0 20px;
}
.tabActive {
    position: fixed;
    top: 3rem;
    left: unset;
    background: #fff;
    z-index: 10000;
    box-sizing: border-box;
    padding: 0 1.25rem;
    width: 100%;
    max-width: 640px;
}
</style>
